var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-0"},[_c('b-alert',{staticClass:"mb-50",attrs:{"variant":_vm.variant,"show":true}},[_c('div',{staticClass:"alert-body"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }